import { lazy } from "react";
const TestRoutes = lazy(() => import("pages/test"));
const ProjectRoutes = lazy(() => import("pages/project"));
const CourseRoutes = lazy(() => import("pages/course"));
const TeacherRoutes = lazy(() => import("pages/teacher"));
const BranchRoutes = lazy(() => import("pages/branch"));
const UpdateRoutes = lazy(() => import("pages/update"));

export const ROUTE_LIST = [
  {
    key: "product",
    element: <TestRoutes />,
    path: "/product/*",
  },
  {
    key: "project",
    element: <ProjectRoutes />,
    path: "/category/*",
  },
  {
    key: "course",
    element: <CourseRoutes />,
    path: "/appeal/*",
  },
  {
    key: "teacher",
    element: <TeacherRoutes />,
    path: "/about/*",
  },

  {
    key: "branch",
    element: <BranchRoutes />,
    path: "/banner/*",
  },

  {
    key: "update",
    element: <UpdateRoutes />,
    path: "/update/*",
  },
];
